//eslint-disable-next-line
__webpack_public_path__ = window.__wpcal_dist_url;

import Vue from "vue";
import AdminOtherApp from "./AdminOtherApp.vue";

import VModal from "vue-js-modal";
Vue.use(VModal, { dialog: true });

Vue.config.productionTip = false;

import { __, _x, _n, _nx, Tsprintf } from "@/utils/common_func.js";
Vue.prototype.__ = __;
Vue.prototype._x = _x;
Vue.prototype._n = _n;
Vue.prototype._nx = _nx;
Vue.prototype.T__ = __;
Vue.prototype.T_x = _x;
Vue.prototype.T_n = _n;
Vue.prototype.T_nx = _nx;
Vue.prototype.Tsprintf = Tsprintf;

document.addEventListener("DOMContentLoaded", () => {
  window.wpcal_admin_other_vins = new Vue({
    render: h => h(AdminOtherApp)
  }).$mount("#wpcal_admin_other_app");
});
